export enum EntityTypes {
    ANNOUNCEMENT = "Announcement",
    BADGE = "Badge",
    BADGE_EARNED = "BadgeEarned",
    BRIEF = "Brief",
    BRIEF_ASSIGNMENT = "BriefAssignment",
    PROFESSIONAL_SITUATION = "ProfessionalSituation",

    CATEGORY = "Category",
    CLASSROOM = "Classroom",

    EVALUATION = "Evaluation",

    FACTORY = "Factory",
    FOLLOW_UP = "FollowUp",
    FRAMEWORK = "Framework",

    GROUP_CORRECTION = "GroupCorrection",
    GROUP_CORRECTED_SKILL_LEVEL = "GroupCorrectedSkillLevel",
    GROUP_MESSAGE = "GroupMessage",
    GROUP_SPACE = "GroupSpace",
    LEARNER_ASSIGNMENT = "LearnerAssignment",
    GROUP_TASK = "GroupTask",
    GROUP_WORK = "GroupWork",

    LANGUAGE = "Language",
    LEARNER_PROGRESSION = "LearnerProgression",

    MEDIA = "Media",
    MEDIA_SECURED = "MediaSecured",

    NOTIFICATION = "Notification",

    PAGE = "Page",

    RESOURCE = "Resource",

    SELF_EVALUATION = "SelfEvaluation",
    SKILL = "Skill",
    SKILL_BLOCK = "SkillBlock",
    SKILL_DOMAIN = "SkillDomain",
    SKILL_LEVEL = "SkillLevel",
    STATISTIC = "Statistic",

    TAG = "Tag",
    TOPIC = "Topic",

    USER = "User",

    VALIDATION = "Validation",
    WORK = "Work",

    CURRENT_BRAND = "CurrentBrand",

    DATAVIZ_LINE = "DatavizLine",
    DATAVIZ_DAY_POINT = "DatavizDayPoint",

    EDUCATIONAL_SCENARIO_SLOT = "EducationalScenarioSlot",
    EDUCATIONAL_SCENARIO_ITEM = "EducationalScenarioItem",
    EDUCATIONAL_BRIEF = "EducationalBrief",

    COMMENT = "Comment",

    MISSION = "Mission",

    USER_SETTINGS = "UserSettings",

    BRAND = "Brand",

    CALENDAR_EVENT = "CalendarEvent",

    CERTIFICATION_ISSUER = "CertificationIssuer",

    LOCATION = "Location",

    SCENARIO_PERIOD = "ScenarioPeriod",

    REFLECTIVE_ANALYSIS = "ReflectiveAnalysis",

    TRAINING_TEMPLATE = "TrainingTemplate",
    TRAINING_ACTION = "TrainingAction",
    TRAINING_PHASE = "TrainingPhase",
    TRAINING_PHASE_SKILL_TARGET = "TrainingPhaseSkillTarget",
    TRAINING_PHASE_PROFESSIONAL_SITUATION = "TrainingPhaseProfessionalSituation",
}
